import { render, staticRenderFns } from "./volume-detail.vue?vue&type=template&id=786d7a5a&"
import script from "./volume-detail.vue?vue&type=script&lang=js&"
export * from "./volume-detail.vue?vue&type=script&lang=js&"
import style0 from "./volume-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports